<template>
    <div name="history" class="history" v-if="step === 0"> 
        <img class="image" src="../../assets/showcase/xi/history/list/1.png" />
        <img class="image" src="../../assets/showcase/xi/history/list/2.png" @click="stepChange(1)" />
        <img class="image" src="../../assets/showcase/xi/history/list/3.png" />
        <img class="image" src="../../assets/showcase/xi/history/list/4.png" />
        <img class="image" src="../../assets/showcase/xi/history/list/5.png" @click="stepChange(2)"/>
        <img class="image" src="../../assets/showcase/xi/history/list/6.png" @click="goDetail(0)" />
        <img class="image" src="../../assets/showcase/xi/history/list/7.png" @click="goDetail(1)"/>
        <img class="image" src="../../assets/showcase/xi/history/list/8.png" />
    </div>
    <div class="history" v-else-if="step === 1">
        <img class="image" src="../../assets/showcase/xi/history/hospital/1.png" />
        <img class="image" src="../../assets/showcase/xi/history/hospital/2.png" @click="stepChange(0)" />
        <img class="image" src="../../assets/showcase/xi/history/hospital/3.png"  />
        <img class="image" src="../../assets/showcase/xi/history/hospital/4.png" @click="goBooking"/>
        <img class="image" src="../../assets/showcase/xi/history/hospital/5.png" />
    </div>
    <div class="history" v-else-if="step === 2">
        <!-- 예진지 -->
        <div class="history" v-if="premedicalstep === 0">
            <img class="image" src="../../assets/showcase/xi/history/premedical/1.png"  @click="() => {step = 0; premedicalstep = 0; scrollToTop}"/>
            <img class="image" src="../../assets/showcase/xi/history/premedical/2.png" />
            <img class="image fixed" src="../../assets/showcase/xi/history/premedical/3.png" @click="() => { premedicalstep = 1; scrollToTop()} "/>
        </div>
        <div class="history" v-else>
            <img class="image" src="../../assets/showcase/xi/history/premedical/4.png" @click="() => {premedicalstep = 0; scrollToTop()}" />
            <img class="image" src="../../assets/showcase/xi/history/premedical/5.png" />
            <img class="image fixed" src="../../assets/showcase/xi/history/premedical/6.png" @click="() => {step = 0; premedicalstep = 0; scrollToTop()}"/>
        </div>
    </div>
    <div class="history" v-else-if="step === 3">

    </div>
</template>

<script>
export default {
    name: 'history',
    data: function()
    {
        return {
            step: 0,
            preStep: 0,
            premedicalstep: 0
        }
    },
    methods: {
        scrollToTop() {
            const el = document.getElementById('app')
            if (el) {
                el.scrollTo({
                    top: 0               
                })
            }
        },
        stepChange: function(step)
        {
            this.scrollToTop();
            this.preStep = this.step;
            this.step = step;
        },
        goDetail: function(hospital)
        {
            this.scrollToTop();
            this.$emit('goDetail', hospital);   
        },
        goBooking: function()
        {
            this.$emit('goBooking')
        }
    }   
}
</script>

<style scoped>
    .history {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        background: #FFF;
    }
    .image {
        width: 100%;
    }
    .fixed {
        bottom: calc(100vw * 120 / 375);
        position: fixed; 
        width: calc(100% - 12.4px - 8.2vw);
    }
</style>


// WEBPACK FOOTER //
// src/components/showcase/History.vue